import script from "./AdminNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNotifications.vue?vue&type=script&setup=true&lang=js"

import "./AdminNotifications.vue?vue&type=style&index=0&id=295ac799&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295ac799"]])

export default __exports__